import { useEffect } from 'react';
import { forcedHeaderStateSelectors } from './useForcedHeaderState.selectors.js';

const activeLocks = {
  expand: 0,
  collapse: 0
};
function useForceHeaderExpanded(enabled) {
  useEffect(() => {
    if (enabled) {
      onLockStateChanged(forcedHeaderStateSelectors.expanded.className, ++activeLocks.expand);
    }
    return () => {
      if (enabled) {
        onLockStateChanged(forcedHeaderStateSelectors.expanded.className, --activeLocks.expand);
      }
    };
  }, [enabled]);
}
function useForceHeaderCollapsed(enabled) {
  useEffect(() => {
    if (enabled) {
      onLockStateChanged(forcedHeaderStateSelectors.collapsed.className, ++activeLocks.collapse);
    }
    return () => {
      if (enabled) {
        onLockStateChanged(forcedHeaderStateSelectors.collapsed.className, --activeLocks.collapse);
      }
    };
  }, [enabled]);
}
function onLockStateChanged(selector, lockCount) {
  document.documentElement.classList.toggle(selector, lockCount > 0);
}

export { useForceHeaderCollapsed, useForceHeaderExpanded };
//# sourceMappingURL=useForceHeaderState.js.map
